<template>
  <div
    :class="classes"
    v-html="value"
  ></div>
</template>

<script>
export default {
  name: 'TextPanel',
  props: ['value', 'className'],
  computed: {
    classes() {
      const defaultClass = 'border border-grey-700 bg-grey-800';
      return `w-full rounded-lg p-4 text-white text-sm ${this.className || defaultClass}`;
    }
  }
};
</script>
